
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lTDpI", function(module, exports) {

$parcel$export(module.exports, "PremiumFeatureDeeplinks", () => $168e181c3998994c$export$d213136284bb1cdf);

var $1NBp8 = parcelRequire("1NBp8");
const $168e181c3998994c$export$5b8f1e0a69cf5e54 = {
    AI: 'https://www.atlassian.com/platform/artificial-intelligence',
    TeamCalendars: 'https://www.atlassian.com/software/confluence/team-calendars',
    Whiteboard: 'https://www.atlassian.com/software/confluence/whiteboards',
    Automation: 'https://www.atlassian.com/software/confluence/automation',
    Analytics: 'https://support.atlassian.com/confluence-cloud/docs/view-insights-on-spaces/',
    CompanyHub: 'https://www.atlassian.com/software/confluence/use-cases/intranet-software',
    ContentManager: 'https://support.atlassian.com/confluence-cloud/docs/manage-your-content-tree/',
    SpacePermission: 'https://support.atlassian.com/confluence-cloud/docs/what-are-space-permissions/'
};
class $168e181c3998994c$export$d213136284bb1cdf {
    getAi() {
        return $168e181c3998994c$export$5b8f1e0a69cf5e54.AI;
    }
    getTeamCalendars() {
        const spaceKeys = [
            this.currentSpaceKey,
            this.starredSpaceKey,
            this.recentSpaceKey
        ];
        const spaceKey = spaceKeys.find((spaceKey)=>spaceKey !== null && spaceKey !== undefined);
        if (!spaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.TeamCalendars;
        return (0, $1NBp8.SPACE_CALENDARS).toUrl({
            spaceKey: spaceKey
        });
    }
    getWhiteboard({ source: source } = {}) {
        if (!this.personalSpaceKey || !source) return $168e181c3998994c$export$5b8f1e0a69cf5e54.Whiteboard;
        return (0, $1NBp8.CREATE_CONTENT).toUrl({
            contentType: 'whiteboard'
        }, {
            query: {
                spaceKey: this.personalSpaceKey,
                source: source
            }
        });
    }
    getAutomationEndUser() {
        if (!this.personalSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.Automation;
        return (0, $1NBp8.SPACE_SETTINGS_AUTOMATION).toUrl({
            spaceKey: this.personalSpaceKey
        }, {
            hash: '#/tab/rule-library'
        });
    }
    getAutomationAdmin() {
        return (0, $1NBp8.ADMIN_GLOBAL_AUTOMATION).toUrl({}, {
            hash: '#/tab/rule-library'
        });
    }
    getAnalytics() {
        if (!this.popularSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.Analytics;
        return (0, $1NBp8.SPACE_ANALYTICS).toUrl({
            spaceKey: this.popularSpaceKey
        });
    }
    getCompanyHub({ isCompanyHubEnabled: isCompanyHubEnabled } = {}) {
        if (!isCompanyHubEnabled) return $168e181c3998994c$export$5b8f1e0a69cf5e54.CompanyHub;
        /* /wiki/company-hub route shows not found screen if CH hasn't been created, so we are using the create CH aritcle link for now
     Details: https://atlassian.slack.com/archives/C05G147TUQ1/p1725038871932349 */ return 'https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub/';
    }
    getMissionControl() {
        return (0, $1NBp8.ADMIN_CENTER).toUrl();
    }
    getContentManager() {
        if (!this.popularSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.ContentManager;
        return (0, $1NBp8.SPACE_BULK_TOOLS).toUrl({
            spaceKey: this.popularSpaceKey
        });
    }
    getSpacePermission() {
        if (!this.personalSpaceKey) return $168e181c3998994c$export$5b8f1e0a69cf5e54.SpacePermission;
        return (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: this.personalSpaceKey,
            tab: 'users'
        });
    }
    constructor({ recentSpaceKey: recentSpaceKey, starredSpaceKey: starredSpaceKey, currentSpaceKey: currentSpaceKey, personalSpaceKey: personalSpaceKey, popularSpaceKey: popularSpaceKey } = {}){
        this.recentSpaceKey = void 0;
        this.starredSpaceKey = void 0;
        this.currentSpaceKey = void 0;
        this.personalSpaceKey = void 0;
        this.popularSpaceKey = void 0;
        this.recentSpaceKey = recentSpaceKey;
        this.starredSpaceKey = starredSpaceKey;
        this.currentSpaceKey = currentSpaceKey;
        this.personalSpaceKey = personalSpaceKey;
        this.popularSpaceKey = popularSpaceKey;
    }
}

});

parcelRegister("87Tvl", function(module, exports) {

$parcel$export(module.exports, "PremiumTipPromptSlideIn", () => $8ccf2e25f8cd4905$export$630533387c9f0a94);

var $gwFzn = parcelRequire("gwFzn");

var $g9Srd = parcelRequire("g9Srd");
var $h3cbw = parcelRequire("h3cbw");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $54BeQ = parcelRequire("54BeQ");
const $8ccf2e25f8cd4905$var$containerStyles = (0, $ecnYn.xcss)({
    position: 'fixed',
    top: 'space.800',
    right: 'space.250',
    zIndex: 'layer'
});
const $8ccf2e25f8cd4905$export$630533387c9f0a94 = ({ shouldShow: shouldShow, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8ccf2e25f8cd4905$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g9Srd.default), {
        appear: true
    }, shouldShow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h3cbw.default), {
        enterFrom: "right",
        exitTo: "right",
        fade: "in"
    }, (slideInProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", slideInProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $54BeQ.PremiumTipPrompt), props));
    })));
};

});
parcelRegister("54BeQ", function(module, exports) {

$parcel$export(module.exports, "PremiumTipPrompt", () => $8698c3e14e529722$export$8ad71c2a22fd7e68);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $iNP4c = parcelRequire("iNP4c");

var $lnqHu = parcelRequire("lnqHu");

var $1qfLF = parcelRequire("1qfLF");

var $7hXDW = parcelRequire("7hXDW");
const $8698c3e14e529722$var$i18n = (0, $2nPZH.defineMessages)({
    header: {
        id: "premium-trial.premium-tip-prompt.header",
        defaultMessage: "Premium tip"
    },
    close: {
        id: "premium-trial.premium-tip-prompt.close",
        defaultMessage: "Close Premium tip"
    }
});
const $8698c3e14e529722$var$promptContainerStyles = (0, $ecnYn.xcss)({
    width: '387px',
    borderRadius: 'borderRadius.medium',
    boxShadow: 'elevation.shadow.overlay'
});
const $8698c3e14e529722$var$headerStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.purple'
});
const $8698c3e14e529722$var$titleStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $8698c3e14e529722$var$descriptionStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $8698c3e14e529722$var$actionStyles = (0, $ecnYn.xcss)({
    textDecoration: 'none'
});
const $8698c3e14e529722$var$primaryActionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.purple',
    ':hover': {
        color: 'color.text.accent.purple'
    },
    ':visited': {
        color: 'color.text.accent.purple'
    },
    ':visited:active': {
        color: 'color.text.accent.purple'
    }
});
const $8698c3e14e529722$var$secondaryActionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.gray',
    ':hover': {
        color: 'color.text.accent.gray'
    },
    ':visited': {
        color: 'color.text.accent.gray'
    },
    ':visited:active': {
        color: 'color.text.accent.gray'
    }
});
const $8698c3e14e529722$var$Action = ({ testId: testId, children: children, link: link, onClick: onClick, appearance: appearance = 'primary' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fpGTa.default), {
        testId: testId,
        role: link ? 'link' : 'button',
        xcss: [
            $8698c3e14e529722$var$actionStyles,
            appearance === 'primary' ? $8698c3e14e529722$var$primaryActionStyles : $8698c3e14e529722$var$secondaryActionStyles
        ],
        href: link?.href || '#',
        target: link?.target,
        onClick: onClick
    }, children);
};
const $8698c3e14e529722$export$8ad71c2a22fd7e68 = ({ title: title, description: description, onClose: onClose, primaryAction: primaryAction, secondaryAction: secondaryAction })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8698c3e14e529722$var$promptContainerStyles,
        paddingBlockEnd: "space.200",
        backgroundColor: "elevation.surface.overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        backgroundColor: "color.background.accent.purple.subtlest",
        paddingBlock: "space.075",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iNP4c))), {
        color: "var(--ds-icon-accent-purple, #8270DB)",
        label: formatMessage($8698c3e14e529722$var$i18n.header)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "xsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8698c3e14e529722$var$headerStyles
    }, formatMessage($8698c3e14e529722$var$i18n.header)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        onClick: onClose,
        label: formatMessage($8698c3e14e529722$var$i18n.close)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8698c3e14e529722$var$titleStyles
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8698c3e14e529722$var$descriptionStyles
    }, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        separator: "\xb7"
    }, primaryAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8698c3e14e529722$var$Action, {
        testId: "premium-tip-primary-action",
        link: primaryAction.link,
        onClick: primaryAction.onClick
    }, primaryAction.content), secondaryAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8698c3e14e529722$var$Action, {
        testId: "premium-tip-secondary-action",
        link: secondaryAction.link,
        onClick: secondaryAction.onClick,
        appearance: "subtle"
    }, secondaryAction.content))))));
};

});


parcelRegister("ix7k7", function(module, exports) {

$parcel$export(module.exports, "PremiumMessages", () => $3f46a5d57ab16e64$export$3448f1579861f49c);
$parcel$export(module.exports, "PremiumMessagesCadenceState", () => $3f46a5d57ab16e64$export$e0332a1b1195e346);

var $3VrqJ = parcelRequire("3VrqJ");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
var $3f46a5d57ab16e64$export$3448f1579861f49c = /*#__PURE__*/ function(PremiumMessages) {
    PremiumMessages["Automation"] = "automation";
    PremiumMessages["Generic"] = "generic";
    return PremiumMessages;
}({});
class $3f46a5d57ab16e64$export$e0332a1b1195e346 {
    _init(mainKey) {
        switch(mainKey){
            case "automation":
                this.mainKey = $3f46a5d57ab16e64$export$e0332a1b1195e346.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE;
                break;
            case "generic":
                this.mainKey = $3f46a5d57ab16e64$export$e0332a1b1195e346.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE;
                break;
            default:
                throw new Error('Invalid main key');
        }
    }
    constructor(mainKey){
        // 30 days in seconds
        this.mainKey = '';
        this.isStorageKEYDismissed = ()=>{
            const cadence = this.getMessageCadence();
            return cadence < 0;
        };
        this.setStorageKEY = (cadence)=>{
            const timestamp = Date.now();
            (0, $e9zUf.confluenceLocalStorageInstance).setItem(this.getMainKey(), `${timestamp};${cadence}`, $3f46a5d57ab16e64$export$e0332a1b1195e346.expirationTime);
        };
        this.getDayDifference = ()=>{
            const timestamp = parseInt(this.getStorageKEY().split(';')[0]);
            const currentDate = Date.now();
            return (0, $3VrqJ.default)(currentDate, timestamp);
        };
        this.messageSeenLongerThanADay = ()=>{
            if (!this.getStorageKEY()) return true;
            return this.getDayDifference() >= 1;
        };
        this.dismissMessage = ()=>{
            if (this.isStorageKEYDismissed()) return;
            this.setStorageKEY(-1);
        };
        this.getMainKey = ()=>{
            return this.mainKey;
        };
        this.getStorageKEY = ()=>{
            return (0, $e9zUf.confluenceLocalStorageInstance).getItem(this.getMainKey());
        };
        this.getMessageCadence = ()=>{
            if (this.getStorageKEY() === null || this.getStorageKEY() === undefined) return 1;
            return parseInt(this.getStorageKEY().split(';')[1]);
        };
        this.setMessageNextCadence = ()=>{
            if (!this.canShowMessage()) return;
            const nextCadence = this.getMessageCadence() + 1;
            if (nextCadence > 5) {
                this.dismissMessage();
                return;
            }
            this.setStorageKEY(nextCadence);
        };
        this.canShowMessage = ()=>{
            if (this.isStorageKEYDismissed()) return false;
            if (this.getMessageCadence() > 5) return false;
            if (!this.messageSeenLongerThanADay()) return false;
            return true;
        };
        this._init(mainKey);
    }
}
$3f46a5d57ab16e64$export$e0332a1b1195e346.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE;
$3f46a5d57ab16e64$export$e0332a1b1195e346.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE;
$3f46a5d57ab16e64$export$e0332a1b1195e346.expirationTime = 2592000;

});
parcelRegister("3VrqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dbbf9039689335a$export$2e2bcd8739ae039);

var $jn4Wd = parcelRequire("jn4Wd");

var $4voUZ = parcelRequire("4voUZ");

var $bgttk = parcelRequire("bgttk");

var $4mCpo = parcelRequire("4mCpo");

var $eLYqa = parcelRequire("eLYqa");

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");

var $7IxPz = parcelRequire("7IxPz");
function $2dbbf9039689335a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6Z3KL.default)(2, arguments);
    var dateLeft = (0, $4YLNd.default)(dirtyDateLeft);
    var dateRight = (0, $4YLNd.default)(dirtyDateRight);
    if (!(0, $4mCpo.default)(dateLeft) || !(0, $4mCpo.default)(dateRight)) return NaN;
    var calendarDifference = (0, $4voUZ.default)(dateLeft, dateRight);
    var sign = calendarDifference < 0 ? -1 : 1;
    var weeks = (0, $7IxPz.default)(calendarDifference / 7);
    var result = weeks * 5;
    dateRight = (0, $jn4Wd.default)(dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $bgttk.default)(dateLeft, dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $eLYqa.default)(dateRight) ? 0 : sign;
        dateRight = (0, $jn4Wd.default)(dateRight, sign);
    }
    return result === 0 ? 0 : result;
}

});
parcelRegister("eLYqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac1452dbdbef935c$export$2e2bcd8739ae039);

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $ac1452dbdbef935c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6Z3KL.default)(1, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    var day = date.getDay();
    return day === 0 || day === 6;
}

});



parcelRegister("2nlFZ", function(module, exports) {

$parcel$export(module.exports, "PremiumTipType", () => $5865c72abef83e2a$export$8e485996e2a65704);
var $5865c72abef83e2a$export$8e485996e2a65704 = /*#__PURE__*/ function(PremiumTipType) {
    PremiumTipType["AUTOMATION"] = "automation";
    PremiumTipType["GENERIC"] = "generic";
    return PremiumTipType;
}({});

});

parcelRegister("brAHV", function(module, exports) {

$parcel$export(module.exports, "MODAL_TRIGGER", () => $c48461bf82b3a37e$export$9d84cfc6d3c9c31c);
$parcel$export(module.exports, "OnboardingManualTrialModal", () => $c48461bf82b3a37e$export$ee19e0d1f60d67c2);
/* OnboardingManualTrialModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $xQxzY = parcelRequire("xQxzY");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $lnqHu = parcelRequire("lnqHu");

var $gj7hi = parcelRequire("gj7hi");

var $6xdDU = parcelRequire("6xdDU");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $inPa6 = parcelRequire("inPa6");

var $lOHzS = parcelRequire("lOHzS");

var $3Mg7y = parcelRequire("3Mg7y");

var $fxBfz = parcelRequire("fxBfz");

var $8DN9t = parcelRequire("8DN9t");

var $lTRsf = parcelRequire("lTRsf");

var $ctmPb = parcelRequire("ctmPb");

var $g7f9W = parcelRequire("g7f9W");

var $4NZXC = parcelRequire("4NZXC");

var $ZDq1z = parcelRequire("ZDq1z");

var $fXbFR = parcelRequire("fXbFR");

var $dIouf = parcelRequire("dIouf");

var $1ytiN = parcelRequire("1ytiN");

var $7Sm4c = parcelRequire("7Sm4c");

var $7CeAz = parcelRequire("7CeAz");

var $cLo2u = parcelRequire("cLo2u");

var $e9zUf = parcelRequire("e9zUf");

var $9wGTI = parcelRequire("9wGTI");

var $lsxnT = parcelRequire("lsxnT");

var $jhwJP = parcelRequire("jhwJP");

var $d2n6w = parcelRequire("d2n6w");

var $cmzkE = parcelRequire("cmzkE");

var $lTDpI = parcelRequire("lTDpI");

var $bnKFE = parcelRequire("bnKFE");
const $c48461bf82b3a37e$var$i18nBase = (0, $2nPZH.defineMessages)({
    modalTitle: {
        id: "premium-trial.onboarding.mt.modal.title",
        defaultMessage: "Welcome to your Premium trial"
    },
    modalDescription: {
        id: "premium-trial.onboarding.mt.modal.description",
        defaultMessage: "Get started by exploring our 5 most popular features."
    },
    videoButtonText: {
        id: "premium-trial.onboarding.mt.video-button.text",
        defaultMessage: "Watch a summary of Premium"
    },
    /* features */ aiTitle: {
        id: "premium-trial.onboarding.mt.ai.title",
        defaultMessage: "Atlassian Intelligence (AI)"
    },
    aiDesciption: {
        id: "premium-trial.onboarding.mt.ai.description",
        defaultMessage: "Work smarter by leveraging AI-powered editing experiences to create and summarize content."
    },
    aiAction: {
        id: "premium-trial.onboarding.mt.ai.action",
        defaultMessage: "Discover the power of AI"
    },
    companyHubTitle: {
        id: "premium-trial.onboarding.mt.company-hub.title",
        defaultMessage: "Company Hub"
    },
    companyHubDescription: {
        id: "premium-trial.onboarding.mt.company-hub.description",
        defaultMessage: "Help your teams stay connected with a centralized intranet for key announcements and resources."
    },
    companyHubAction: {
        id: "premium-trial.onboarding.mt.company-hub.action",
        defaultMessage: "Customize my company hub"
    },
    automationTitle: {
        id: "premium-trial.onboarding.mt.automation.title",
        defaultMessage: "Automation"
    },
    automationDescription: {
        id: "premium-trial.onboarding.mt.automation.description",
        defaultMessage: "Save time by creating rules to change content status, create a Jira task, and more."
    },
    automationAction: {
        id: "premium-trial.onboarding.mt.automation.action",
        defaultMessage: "Build an automation rule"
    },
    missionControlTitle: {
        id: "premium-trial.onboarding.mt.mission-control.title",
        defaultMessage: "Mission control"
    },
    missionControlDescription: {
        id: "premium-trial.onboarding.mt.mission-control.description",
        defaultMessage: "Boost your team\u2019s productivity with insights and controls for data-driven improvements."
    },
    missionControlAction: {
        id: "premium-trial.onboarding.mt.mission-control.action",
        defaultMessage: "Go to mission control"
    },
    contentManagerTitle: {
        id: "premium-trial.onboarding.mt.content-manager.title",
        defaultMessage: "Content manager"
    },
    contentManagerDescription: {
        id: "premium-trial.onboarding.mt.content-manager.description",
        defaultMessage: "Keep content organized and make bulk changes across hundreds of pages simultaneously."
    },
    contentManagerAction: {
        id: "premium-trial.onboarding.mt.content-manager.action",
        defaultMessage: "View my content manager"
    },
    teamCalendarsTitle: {
        id: "premium-trial.onboarding.mt.team-calendars.title",
        defaultMessage: "Team calendars"
    },
    teamCalendarsDescription: {
        id: "premium-trial.onboarding.mt.team-calendars.description",
        defaultMessage: "Keep one single source of truth for your team\u2019s schedules and due dates."
    },
    teamCalendarsAction: {
        id: "premium-trial.onboarding.mt.team-calendars.action",
        defaultMessage: "Go to team calendars"
    },
    unlimitedWhiteBoardsTitle: {
        id: "premium-trial.onboarding.mt.unlimited-whiteboards.title",
        defaultMessage: "Whiteboards and Jira without limits"
    },
    unlimitedWhiteBoardsDescription: {
        id: "premium-trial.onboarding.mt.unlimited-whiteboards.description",
        defaultMessage: "Brainstorm without boundaries and turn ideas into Jira tasks from one single location."
    },
    unlimitedWhiteBoardsAction: {
        id: "premium-trial.onboarding.mt.unlimited-whiteboards.action",
        defaultMessage: "Create a whiteboard"
    },
    analyticsTitle: {
        id: "premium-trial.onboarding.mt.analytics.title",
        defaultMessage: "Analytics"
    },
    analyticsDescription: {
        id: "premium-trial.onboarding.mt.analytics.description",
        defaultMessage: "See user engagement and views at the site, space, and content level."
    },
    analyticsAction: {
        id: "premium-trial.onboarding.mt.analytics.action",
        defaultMessage: "View analytics"
    }
});
const $c48461bf82b3a37e$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    contentManagerDescription: {
        id: "premium-trial.onboarding.mt.content-manager.description.livedocs",
        defaultMessage: "Keep content organized and make bulk changes across hundreds of pages and live docs simultaneously."
    }
});
const $c48461bf82b3a37e$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($c48461bf82b3a37e$var$i18nBase, $c48461bf82b3a37e$var$i18nLiveDocs);
const $c48461bf82b3a37e$var$imageContainerStyles = (0, $ecnYn.xcss)({
    width: '145',
    minInlineSize: 'max-content'
});
const $c48461bf82b3a37e$var$imageStyles = null;
var $c48461bf82b3a37e$export$9d84cfc6d3c9c31c = /*#__PURE__*/ function(MODAL_TRIGGER) {
    MODAL_TRIGGER["ONBOARDING"] = "onboarding";
    MODAL_TRIGGER["GENERIC_PREMIUM_TIP"] = "genericPremiumTip";
    return MODAL_TRIGGER;
}({});
var $c48461bf82b3a37e$var$Features = /*#__PURE__*/ function(Features) {
    Features["AI"] = "atlassianIntelligence";
    Features["TEAM_CALENDARS"] = "teamCalendars";
    Features["COMPANY_HUB"] = "companyHub";
    Features["UNLIMITED_WHITEBOARDS"] = "unlimitedWhiteboards";
    Features["AUTOMATION"] = "automation";
    Features["MISSION_CONTROL"] = "missionControl";
    Features["CONTENT_MANAGER"] = "contentManager";
    Features["ANALYTICS"] = "analytics";
    return Features;
}($c48461bf82b3a37e$var$Features || {});
const $c48461bf82b3a37e$var$featuresMapper = [
    {
        key: "atlassianIntelligence",
        title: $c48461bf82b3a37e$var$i18n.aiTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.aiDesciption,
        linkText: $c48461bf82b3a37e$var$i18n.aiAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))),
        showToAdmin: true,
        showToEndUser: true
    },
    {
        key: "teamCalendars",
        title: $c48461bf82b3a37e$var$i18n.teamCalendarsTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.teamCalendarsDescription,
        linkText: $c48461bf82b3a37e$var$i18n.teamCalendarsAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        showToAdmin: false,
        showToEndUser: true
    },
    {
        key: "companyHub",
        title: $c48461bf82b3a37e$var$i18n.companyHubTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.companyHubDescription,
        linkText: $c48461bf82b3a37e$var$i18n.companyHubAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctmPb))),
        showToAdmin: true,
        showToEndUser: false
    },
    {
        key: "unlimitedWhiteboards",
        title: $c48461bf82b3a37e$var$i18n.unlimitedWhiteBoardsTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.unlimitedWhiteBoardsDescription,
        linkText: $c48461bf82b3a37e$var$i18n.unlimitedWhiteBoardsAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        showToAdmin: false,
        showToEndUser: true
    },
    {
        key: "automation",
        title: $c48461bf82b3a37e$var$i18n.automationTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.automationDescription,
        linkText: $c48461bf82b3a37e$var$i18n.automationAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))),
        showToAdmin: true,
        showToEndUser: true
    },
    {
        key: "missionControl",
        title: $c48461bf82b3a37e$var$i18n.missionControlTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.missionControlDescription,
        linkText: $c48461bf82b3a37e$var$i18n.missionControlAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7f9W))),
        showToAdmin: true,
        showToEndUser: false
    },
    {
        key: "contentManager",
        title: $c48461bf82b3a37e$var$i18n.contentManagerTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.contentManagerDescription,
        linkText: $c48461bf82b3a37e$var$i18n.contentManagerAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))),
        showToAdmin: true,
        showToEndUser: false
    },
    {
        key: "analytics",
        title: $c48461bf82b3a37e$var$i18n.analyticsTitle,
        bodyText: $c48461bf82b3a37e$var$i18n.analyticsDescription,
        linkText: $c48461bf82b3a37e$var$i18n.analyticsAction,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lTRsf))),
        showToAdmin: false,
        showToEndUser: true
    }
];
const $c48461bf82b3a37e$export$5478df32444b3540 = 'premiumOnboardingManualTrialModal';
const $c48461bf82b3a37e$var$modalClosedLocalStorageKey = 'premium.trial.onboarding.mt.modal.closed';
const $c48461bf82b3a37e$export$ee19e0d1f60d67c2 = ({ onClose: onClose, stop: stop, onCloseComplete: onCloseComplete, modalTrigger: modalTrigger = "onboarding" })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(true);
    const [isLearnMoreVideoOpen, setIsLearnMoreVideoIsOpen] = (0, $gwFzn.useState)(false);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const currentSpaceKey = (0, $cLo2u.useSpaceKey)();
    const { data: { personalSpace: personalSpace, popularSpaces: popularSpaces, starredSpace: starredSpace, recentSpaces: recentSpaces } = {}, error: error } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query OnboardingManualTrialModalQuery{personalSpace:confluence_atlassianUser(current:true){id confluence{hasPersonalSpace space{id alias}}}popularSpaces:popularFeed(first:25){nodes{content{id space{id alias type}}}}starredSpace:spaces(favourite:true first:1 status:"current"){nodes{id alias}}recentSpaces:recentSpaces{id alias}}`);
    const personalSpaceKey = personalSpace?.confluence?.hasPersonalSpace && personalSpace?.confluence?.space?.alias || undefined;
    const popularSpace = popularSpaces?.nodes.find((node)=>node.content?.space?.type !== 'system');
    const popularSpaceKey = popularSpace?.content?.space?.alias || undefined;
    const starredSpaceKey = starredSpace?.nodes?.[0]?.alias || undefined;
    const recentSpaceKey = recentSpaces?.[0]?.alias || undefined;
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const premiumFeatureDeeplinks = (0, $gwFzn.useMemo)(()=>{
        return new (0, $lTDpI.PremiumFeatureDeeplinks)({
            personalSpaceKey: personalSpaceKey,
            popularSpaceKey: popularSpaceKey,
            starredSpaceKey: starredSpaceKey,
            recentSpaceKey: recentSpaceKey,
            currentSpaceKey: currentSpaceKey || undefined
        });
    }, [
        personalSpaceKey,
        popularSpaceKey,
        starredSpaceKey,
        recentSpaceKey,
        currentSpaceKey
    ]);
    const featureLinksMapper = (0, $gwFzn.useMemo)(()=>{
        return {
            ["atlassianIntelligence"]: premiumFeatureDeeplinks.getAi(),
            ["teamCalendars"]: premiumFeatureDeeplinks.getTeamCalendars(),
            ["companyHub"]: premiumFeatureDeeplinks.getCompanyHub({
                isCompanyHubEnabled: isCompanyHubEntryPointEnabled
            }),
            ["unlimitedWhiteboards"]: premiumFeatureDeeplinks.getWhiteboard({
                source: $c48461bf82b3a37e$export$5478df32444b3540
            }),
            ["automation"]: isSiteAdmin ? premiumFeatureDeeplinks.getAutomationAdmin() : premiumFeatureDeeplinks.getAutomationEndUser(),
            ["missionControl"]: premiumFeatureDeeplinks.getMissionControl(),
            ["contentManager"]: premiumFeatureDeeplinks.getContentManager(),
            ["analytics"]: premiumFeatureDeeplinks.getAnalytics()
        };
    }, [
        isCompanyHubEntryPointEnabled,
        isSiteAdmin,
        premiumFeatureDeeplinks
    ]);
    const featuresToShow = $c48461bf82b3a37e$var$featuresMapper.filter((feature)=>isSiteAdmin && feature.showToAdmin || !isSiteAdmin && feature.showToEndUser);
    if ((0, $9wGTI.fg)('a4c_free_and_standard_editions')) {
        const automationIdx = featuresToShow.findIndex((feature)=>feature.key === "automation");
        featuresToShow.splice(automationIdx, 1);
    }
    const modalRef = (0, $gwFzn.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(modalRef);
    const hasLinkEventFiredWithDwellTime = (0, $gwFzn.useRef)(false);
    const closeModal = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'ptoManualTrialModalCloseButton',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    dwellTime: getDwellTime(),
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        setIsOpen(false);
        onClose?.();
    }, [
        createAnalyticsEvent,
        getDwellTime,
        onClose,
        modalTrigger
    ]);
    const openLearnMoreVideo = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'premiumVideoModalButton',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    dwellTime: getDwellTime(),
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        setIsLearnMoreVideoIsOpen(true);
    }, [
        createAnalyticsEvent,
        getDwellTime,
        modalTrigger
    ]);
    const closeLearnMoreVideo = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'premiumVideoModalCloseButton',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        setIsLearnMoreVideoIsOpen(false);
    }, [
        createAnalyticsEvent,
        modalTrigger
    ]);
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    isSiteAdmin: isSiteAdmin,
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        modalTrigger
    ]);
    const onLinkClick = (0, $gwFzn.useCallback)((feature)=>{
        let dwellTime = {};
        if (!hasLinkEventFiredWithDwellTime.current) {
            dwellTime = {
                dwellTime: getDwellTime()
            };
            hasLinkEventFiredWithDwellTime.current = true;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'premiumFeatureDeeplink',
                source: $c48461bf82b3a37e$export$5478df32444b3540,
                attributes: {
                    feature: feature,
                    isSiteAdmin: isSiteAdmin,
                    ...dwellTime,
                    modalTrigger: modalTrigger
                }
            }
        }).fire();
        stop?.();
        modalTrigger === "onboarding" && (0, $e9zUf.confluenceLocalStorageInstance).setItem($c48461bf82b3a37e$var$modalClosedLocalStorageKey, 'true');
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        stop,
        getDwellTime,
        modalTrigger
    ]);
    if (modalTrigger === "onboarding" && (0, $e9zUf.confluenceLocalStorageInstance).getItem($c48461bf82b3a37e$var$modalClosedLocalStorageKey)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).VIRALITY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, isLearnMoreVideoOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnKFE.LearnMoreVideoModal), {
        onClose: closeLearnMoreVideo
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Modal, {
        autoFocus: false,
        width: 752,
        shouldScrollInViewport: true,
        onCloseComplete: onCloseComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        ref: modalRef,
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c48461bf82b3a37e$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d2n6w))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($d2n6w))),
        alt: "Premium trial onboarding modal image",
        className: (0, $35pXk.default)([
            "_5ral1dfr _1tke1osq _1bsb93m8 _4t3i1kdj"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        onClick: closeModal,
        label: "Close Modal"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c48461bf82b3a37e$var$i18n.modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c48461bf82b3a37e$var$i18n.modalDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, featuresToShow.map((feature)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cmzkE.ListItem), {
            label: feature.key,
            bodyText: feature.bodyText,
            linkText: feature.linkText,
            link: featureLinksMapper[feature.key],
            icon: feature.icon,
            title: feature.title,
            onLinkClick: ()=>onLinkClick(feature.key),
            key: feature.key
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS))),
        onClick: openLearnMoreVideo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $c48461bf82b3a37e$var$i18n.videoButtonText))))))))));
};

});
parcelRegister("d2n6w", function(module, exports) {
module.exports = new URL("Illustration.bc0cbd7b.svg", import.meta.url).toString();

});

parcelRegister("cmzkE", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $01ec9082b70ec97f$export$a7b06bfba60a8a78);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $8lYIw = parcelRequire("8lYIw");
const $01ec9082b70ec97f$var$iconBoxStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.information',
    height: '40px',
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'border.radius.100'
});
const $01ec9082b70ec97f$var$imgStyle = (0, $ecnYn.xcss)({
    width: '40px',
    paddingTop: 'space.050'
});
const $01ec9082b70ec97f$var$titleTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
const $01ec9082b70ec97f$var$bodyTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $01ec9082b70ec97f$var$linkTextStyle = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $01ec9082b70ec97f$export$a7b06bfba60a8a78 = ({ label: label, icon: icon, title: title, bodyText: bodyText, linkText: linkText, link: link, onLinkClick: onLinkClick })=>{
    const Icon = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$imgStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$iconBoxStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
        label: label || '',
        color: "var(--ds-icon-information, #1D7AFC)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$titleTextStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$bodyTextStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), bodyText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $01ec9082b70ec97f$var$linkTextStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8lYIw.Link), {
        target: "_blank",
        href: link,
        onClick: onLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), linkText)))));
};

});

parcelRegister("bnKFE", function(module, exports) {

$parcel$export(module.exports, "LearnMoreVideoModal", () => $dd6c5da567a6ff5f$export$41318e6dd18eedd1);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $lnqHu = parcelRequire("lnqHu");

var $1qfLF = parcelRequire("1qfLF");

var $gdv5Z = parcelRequire("gdv5Z");

var $ekolh = parcelRequire("ekolh");
const $dd6c5da567a6ff5f$var$i18n = (0, $2nPZH.defineMessages)({
    closeModal: {
        id: "premium-trial.learn-more.video.close-modal.label",
        defaultMessage: "Close video modal"
    }
});
const $dd6c5da567a6ff5f$export$41318e6dd18eedd1 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        onClose: onClose,
        // To ensure that the close button isn't in focus when the modal is opened, disable auto focus on the modal
        autoFocus: false,
        width: "large",
        height: "474px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        style: {
            position: 'relative',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            right: "var(--ds-space-negative-400, -32px)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage($dd6c5da567a6ff5f$var$i18n.closeModal),
        // leave label empty for CrossIcon on purpose because label is provided in the line above
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/UYYe0Qbs9fs?si=PtVPpFx_Jiued9de",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen",
        title: "Explore Confluence Premium"
    })));
};

});



//# sourceMappingURL=PremiumTrialOnboardingModal.5234eff9.js.map
